import type { Transition } from "@uirouter/core";

import Sentry from "@similarweb/sentry-logger";

import { swSettings } from "app/common/services/swSettings";
import { getQueryOptions } from "app/modules/api-client";
import { ACTIVATION_HOME_ROUTE } from "app/pages/activation/routing/constants";
import queryClient from "single-spa/react-app/query-client";

import { getAlertsAvailableDates, getAlertsDefaultDuration } from "../utils";

import type { IAlertsRouteParams } from "./routeParams";

export const onRedirectToAlerts = () => {
    return async (transition: Transition) => {
        const toParams = transition.params<IAlertsRouteParams>("to");

        try {
            const activationSet = await queryClient.fetchQuery(
                getQueryOptions(
                    {
                        tag: "Activation",
                        methodName: "userdataActivationDetail",
                    },
                    toParams.key,
                ),
            );

            if (!activationSet) {
                return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
            }

            if (!swSettings.allowedDuration(toParams.duration, "Alerts")) {
                const { minDate, maxDate } = getAlertsAvailableDates();

                if (!minDate || !maxDate) {
                    return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
                }

                return {
                    params: {
                        ...toParams,
                        duration: getAlertsDefaultDuration({ minDate, maxDate }),
                        isDurationChanged: true,
                    },
                };
            }
        } catch (e) {
            Sentry.errorTracker({
                e,
                message: "Error in onRedirectToAlerts check, redirecting to home route",
                level: "error",
                params: { extra: { toParams } },
            });

            return transition.router.stateService.target(ACTIVATION_HOME_ROUTE);
        }
    };
};
